export enum Action {
    Increment = 1,
    Decrement = 0
}

export type StepOne = {
    name: string
}
